import styled from 'styled-components';

export const StyledInstructions = styled.div`margin-bottom: 1em; font-style: italic; color: #555; font-size: 1.2em; line-height: 1.1;`;
